<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>佣金调整</h2>
        <p>已确认成交不覆盖原快照，所有增减通过调整单追溯</p>
      </div>
      <el-button
        type="primary"
        @click="dialog = true"
      >
        新建调整单
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="user_name"
          label="员工"
        />
        <el-table-column
          prop="transaction_id"
          label="成交编号"
        />
        <el-table-column
          prop="type"
          label="类型"
        >
          <template #default="{ row }">
            {{ row.type === 'INCREASE' ? '增加' : '扣减' }}
          </template>
        </el-table-column>
        <el-table-column label="调整金额">
          <template #default="{ row }">
            <span :class="Number(row.amount) >= 0 ? 'up' : 'down'">
              {{ Number(row.amount) >= 0 ? '+' : '' }}¥ {{ money(row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reason"
          label="原因"
        />
        <el-table-column
          prop="status"
          label="状态"
        >
          <template #default="{ row }">
            <StatusTag :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button
              v-if="row.status === 'DRAFT'"
              link
              type="primary"
              @click="confirm(row)"
            >
              确认
            </el-button>
            <el-button
              v-if="row.status === 'CONFIRMED'"
              link
              type="danger"
              @click="voidRow(row)"
            >
              作废
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-model="dialog"
      title="新建佣金调整"
      width="520px"
    >
      <el-form label-width="100px">
        <el-form-item
          label="员工"
          required
        >
          <el-select
            v-model="form.userId"
            filterable
          >
            <el-option
              v-for="u in employees"
              :key="u.id"
              :label="u.name"
              :value="u.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="成交核算ID">
          <el-input-number
            v-model="form.transactionCommissionId"
            :min="1"
            :controls="false"
          />
          <div class="hint">可留空，表示非指定成交的人工调整</div>
        </el-form-item>
        <el-form-item
          label="调整金额"
          required
        >
          <el-input-number
            v-model="form.amount"
            :precision="2"
            :controls="false"
          />
          <div class="hint">正数增加，负数扣减</div>
        </el-form-item>
        <el-form-item
          label="调整原因"
          required
        >
          <el-input
            v-model="form.reason"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存草稿
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { commissionApi, organizationApi } from '../api'
import StatusTag from '../components/StatusTag.vue'
const rows = ref([]),
  employees = ref([]),
  loading = ref(false),
  dialog = ref(false),
  saving = ref(false),
  form = reactive({
    userId: null,
    transactionCommissionId: null,
    amount: 0,
    reason: '',
  })
const money = (v) => Math.abs(Number(v || 0)).toFixed(2)
const load = async () => {
  loading.value = true
  try {
    const result = await Promise.all([
      commissionApi.adjustments(),
      organizationApi.employees(),
    ])
    rows.value = result[0]
    employees.value = result[1]
  } finally {
    loading.value = false
  }
}
const save = async () => {
  if (!form.userId || !form.amount || !form.reason)
    return ElMessage.warning('请完整填写调整信息')
  saving.value = true
  try {
    await commissionApi.createAdjustment(form)
    dialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const confirm = async (r) => {
  try {
    await ElMessageBox.confirm('确认后会形成员工应发项目，是否继续？', '确认')
    await commissionApi.confirmAdjustment(r.id)
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '确认失败')
  }
}
const voidRow = async (r) => {
  try {
    const { value } = await ElMessageBox.prompt('请输入作废原因', '作废', {
      inputValidator: (v) => !!v?.trim() || '原因不能为空',
    })
    await commissionApi.voidAdjustment(r.id, value)
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '作废失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p,
.hint {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.up {
  color: #16803c;
}
.down {
  color: #c53030;
}
</style>
